import React from "react";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { FaRegHandPointLeft } from "react-icons/fa";

const PageNotFound = () => {
  return (
    <MainContainer>
      <Card>
        <Code404>404</Code404>

        <Title>Page non trouvée</Title>

        <Text>Désolé, la page que vous recherchez est introuvable.</Text>

        <Links to="/">
          <FaRegHandPointLeft />
          Retour à la page d'accueil
        </Links>
      </Card>
    </MainContainer>
  );
};

export default PageNotFound;

const MainContainer = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 2rem;
`;

const SectionContain = styled.section`
  max-width: 70%;
  margin: auto;
  padding-top: 15rem;

  h1 {
    font-size: 3.5rem;
  }

  p {
    font-size: 1.5rem;
  }
`;

const Card = styled.section`
  text-align: center;
  padding: 3rem 2rem;

  border-radius: 20px;

  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);

  max-width: 500px;
  width: 100%;
`;

const Code404 = styled.h1`
  font-size: 6rem;
  margin-bottom: 1rem;

  background: linear-gradient(to right, #fff, rgba(180, 1, 18, 1));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 480px) {
   {
    font-size: 4rem;
  }
}
`;

const Title = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  letter-spacing: 0.05em;
`;

const Text = styled.p`
  font-size: 1.2rem;
  color: #a8a29e;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const Links = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  text-transform: uppercase;
  font-size: 1.1rem;
  color: #a8a29e;

  padding: 0.6rem 1.2rem;
  border-radius: 999px;

  border: 1px solid rgba(255, 255, 255, 0.2);

  transition: all 0.3s ease;

  &:hover {
    color: #fff;
    border-color: rgba(180, 1, 18, 0.6);
    background: rgba(180, 1, 18, 0.15);
    transform: translateY(-2px);
  }
`;
